import { FeaturedDigitalProductModal } from './Modal'
import { Button } from '@components/gassan-ui'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { Text } from '@components/gassan-ui/Typography/Text'
import { DigitalProductPage } from '@lib/kontent/models/DigitalProductPage'
import Cookies from 'js-cookie'
import { useTranslation } from 'next-i18next'
import { FC, useEffect, useState } from 'react'
import { cn } from '@lib/cn'

const SHOW_DIGITAL_PRODUCTS_STORAGE_KEY = 'show_digital_products'

type FeaturedDigitalProductProps = {
  title: string
  description: string
  content: DigitalProductPage['featured_html_content']
}

export const FeaturedDigitalProduct: FC<FeaturedDigitalProductProps> = ({
  title,
  description,
  content,
}) => {
  const { t } = useTranslation('other')
  const [showIframe, setShowIframe] = useState(false)
  const [showModal, setModal] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setShowIframe(!!Cookies.get(SHOW_DIGITAL_PRODUCTS_STORAGE_KEY))
    }
  }, [])

  return (
    <>
      <div className={cn('mb-8 block', 'md:grid md:grid-cols-6 md:gap-6', 'lg:gap-8')}>
        <div
          className={cn(
            'relative col-span-3 pt-[60%]',
            'sm:pt-[90%]',
            'md:pt-[60%]',
            'lg:col-span-4',
          )}
        >
          <div className="absolute left-0 top-0 flex h-full w-full">
            <div
              className={cn(
                'ease h-full w-full transition-all delay-300 duration-500',
                !showIframe && 'filter-blur pointer-events-none opacity-30',
              )}
              dangerouslySetInnerHTML={{ __html: content.value }}
              data-visible={showIframe ? 'true' : 'false'}
            />
            {!showIframe && (
              <div
                className={cn(
                  'absolute left-0 right-0 top-1/2 mx-auto flex w-[calc(100%-32px)] max-w-[400px] -translate-y-1/2 transform flex-col items-center bg-pampas p-4 text-center',
                  'md:p-6',
                )}
              >
                <Heading variant="h4" as="h2" className="mb-4">
                  {t('viewLatestItem')}
                </Heading>
                <Text className="mb-6 whitespace-pre-line">{t('signUpToViewLatestItem')}</Text>
                <Button variant="dark" onClick={toggleModal}>
                  {t('signup')}
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className={cn('col-span-3 mt-6', 'md:mt-4', 'lg:col-span-2 lg:mt-2')}>
          <Heading variant="h3" as="h2" className="mb-4 md:mb-6">
            {title}
          </Heading>
          <Text className="mb-6 whitespace-pre-line">{description}</Text>
        </div>
      </div>
      {showModal && (
        <FeaturedDigitalProductModal
          title={t('signupForNewsletter')}
          handleToggle={toggleModal}
          handleSuccess={handleSuccess}
        />
      )}
    </>
  )

  function toggleModal() {
    setModal((val) => !val)
  }

  function handleSuccess() {
    setModal(false)
    setShowIframe(true)
    Cookies.set(SHOW_DIGITAL_PRODUCTS_STORAGE_KEY, 'true', { expires: 365 })
  }
}
